import { ISelectItem, SelectItem } from './SelectIem'

export interface IEnquiryReferenceItems {
  employmentTypes: SelectItem[]
  paidLeaveTypes: SelectItem[]
  apprenticeTypes: SelectItem[]
  independentContractorTypes: SelectItem[]
  genuineContractEmployeeTypes: SelectItem[]
  personDescTypes: SelectItem[]
  visaTypes: SelectItem[]
  countryTypes: SelectItem[]
  officeLocationTypes: SelectItem[]
  languageTypes: SelectItem[]

  notSpokenToEmployerTypes: SelectItem[]
  othersAffectedTypes: SelectItem[]
  evidenceTypes: SelectItem[]
}

export interface IEnquirySummary {
  id: string
  isOpen: boolean
  channel: string
  number: string
  createdOn: string
  updatedOn: string
  status: string
  hasRFI: boolean
  hasRFIPendingResponse: boolean
}

export interface IRecommenedLinkInfo {
  name: string
  briefDescription: string
  url: string
}

export interface IRequestInformation {
  id: string
  subject: string
  request: string
  response: string
  responded: string
  status: string
  createdOn: string
  updatedOn: string
}

export class RequestInformationRequest {
  id: string
  enquiryId: string
  response: string

  constructor(init?: IRequestInformation) {
    this.id = init.id
    this.response = init.response || ''
  }
}

export interface IEnquirySaveResponse {
  number: string
  status: string
  success: boolean
}

export interface IEnquiryDetail {
  id: string
  isOpen: boolean
  isSaved: boolean
  isEmployeer: boolean
  isIC: boolean
  isER: boolean
  isenle: boolean
  isEE: boolean
  isSBE: boolean
  isERR: boolean
  channel: string
  number: string
  createdOn: string
  updatedOn: string
  status: string
  requestForInfoType?: string
  requestForInfoSubTypes?: string[]
  otherQuestions?: string
  businessName?: string
  businessABN?: string
  businessAddressLine1?: string
  businessAddressLine2?: string
  businessSuburb?: string
  businessPostcode?: string
  businessState?: string
  noOfEmployees?: string
  employeePostcode?: string
  employeeState?: string
  employeeSuburb?: string
  employmentType?: string
  apprenticeOrTrainee?: string
  paidLeave?: string
  genuineContractEmployeeType?: string
  independentContractor?: string
  completingInternship?: boolean
  visaHolder?: boolean
  dateOfBirth?: string
  personDescription?: string[]
  officeLocation?: string
  interpreterRequired?: boolean
  language?: string
  country?: string
  visaType?: string
  mainDuties?: string
  occupation?: string
  haveSpokenToEmployer?: string
  notSpokenToEmployerReason?: string
  outcomeOfSpokenToEmployer?: string
  hasSupportingEvidence?: boolean
  supportingEvidence?: string[]
  areOthersAffected?: string
  employmentStartDate?: string
  employmentEndDate?: string
  nominateSomeoneToAct?: boolean
  nomineeFullName?: string
  nomineeEmailAddress?: string
  nomineePhone?: string
  hourlyPayRate?: string
  permissionToContact?: string
  employeerFullName?: string
  employeerPhone?: string
  employeerEmailAddress?: string
  otherInformation?: string
  recommendedLinks?: IRecommenedLinkInfo[]
  enquiryResponse?: string
  enquiryTypeLevel1?: string
  enquiryTypeLevel2?: string
  requestInformation: IRequestInformation[]
  crn?: string
  customerType?: string
  isStartedWithAdvisor?: boolean
  hasRFI?: boolean
  hasRFIPendingResponse?: boolean

  agreement?: boolean

  employmentTypes: any[]
  apprenticeTypes: any[]
  officeLocationTypes: any[]
  personDescTypes: any[]
  languageTypes: any[]
  visaTypes: any[]
  genuineContractEmployeeTypes: any[]
  paidLeaveTypes: any[]
  countryTypes: any[]
  independentContractorTypes: any[]
  customerTypes: any[]

  notSpokenToEmployerTypes: any[]
  othersAffectedTypes: any[]
  evidenceTypes: any[]
  occupationTypes: any[]
}

export interface IEnquiryTable {
  size: number
  limit: number
}

export class ReferenceType {
  id: string
  name: string
}

export class EnquiryGetHelpFormValues {
  needInfoAboutId = ''
  needInfoSubAboutId = []
  otherQuestions = ''
  govCMSPages?: IEnquiryGovCMSSearchResponse[]
}

export class EnquiryPreLodgementRequest {
  needInfoAboutId: string
  needInfoSubAboutId: string[]
  otherQuestions: string
  recomendedCMSPages?: IEnquiryGovCMSSearchResponse[]

  constructor(init?: EnquiryGetHelpFormValues) {
    this.needInfoAboutId = init.needInfoAboutId
    this.needInfoSubAboutId = init.needInfoSubAboutId
    this.otherQuestions = init.otherQuestions
    this.recomendedCMSPages = init.govCMSPages
  }
}

export interface IEnquiryGovCMSSearchResponse {
  id: string
  title: string
  link: string
  body: string
}

export interface IEnquiryGovCMSSearchRequest {
  needInfoSubAboutId?: string[]
  otherQuestions: string
}

export class EnquiryGovCMSSearchRequest implements IEnquiryGovCMSSearchRequest {
  needInfoSubAboutId?: string[] = null
  otherQuestions = ''
  constructor(init?: EnquiryGetHelpFormValues) {
    if (init) {
      this.needInfoSubAboutId = init.needInfoSubAboutId
      this.otherQuestions = init.otherQuestions
    }
  }
}

export interface IEnquiryRecommendedLink {
  name: string
  url: string
  briefDescription: string
}

export interface IEnquiryPreLodgementResponse {
  id: string
  enquiryNumber: string
  enquiryStatus: string
  isOpen: boolean
  requestForInfoType?: string
  requestForInfoSubTypes?: string[]
  otherQuestions: string
  recommendedLinks?: IEnquiryRecommendedLink[]
}

export interface IEnquirySelectItems {
  requestForAssistanceInfoCategories: SelectItem[]
  requestForAssistanceInfoSubCategories: SelectItem[]
}

export interface IEnquiryProfileSelectItems {
  businessDescriptions: SelectItem[]
  awards: SelectItem[]
  yesNoUnsure: SelectItem[]
  titles: SelectItem[]
  genders: SelectItem[]
  customerTypes: SelectItem[]
  regions: SelectItem[]
  awardIndustries: SelectItem[]
  awardSubIndustries: SelectItem[]
}

export interface ICurrentUserProfileUpdated {
  result: boolean
}

export interface ICurrentUserProfile {
  titleId?: string
  crn: string
  emailAddress: string
  firstName: string
  lastName: string
  customerTypeId: string
  phone?: string
  businessName?: string
  businessABN?: string
  industryId?: string
  subIndustryId?: string
  businessLocationId?: string
  noOfEmployees?: string
  whatDescribesBusinessId?: string
  modernAwardsId?: string
  coveredByAwardsId?: string
  agreementNameOrCode?: string
  businessCoveredId?: string

  businessDescriptions: any[]
  yesNoUnsure: any[]
  modernAwards: any[]
  titles: any[]
  genders: any[]
  customerTypes: any[]
  regions: any[]
  awardIndustries: any[]
  awardSubIndustries: any[]
}

export class CurrentUserProfile implements ICurrentUserProfile {
  titleId?: string = ''
  crn = ''
  emailAddress = ''
  firstName = ''
  lastName = ''
  customerTypeId = ''
  phone?: string = ''
  businessName?: string = ''
  businessABN?: string = ''
  industryId?: string = ''
  subIndustryId?: string = ''
  businessLocationId?: string = ''
  noOfEmployees?: string = ''
  whatDescribesBusinessId?: string = ''
  modernAwardsId?: string = ''
  coveredByAwardsId?: string = ''
  agreementNameOrCode?: string = ''
  businessCoveredId?: string = ''

  businessDescriptions: any[] = []
  yesNoUnsure: any[] = []
  modernAwards: any[] = []
  titles: any[] = []
  genders: any[] = []
  customerTypes: any[] = []
  regions: any[] = []
  awardIndustries: any[] = []
  awardSubIndustries: any[] = []

  constructor(init?: CurrentUserProfile) {
    if (init) {
      this.titleId = init.titleId
      this.crn = init.crn
      this.emailAddress = init.emailAddress
      this.firstName = init.firstName
      this.lastName = init.lastName
      this.customerTypeId = init.customerTypeId
      this.phone = init.phone
      this.businessName = init.businessName
      this.businessABN = init.businessABN
      this.industryId = init.industryId
      this.subIndustryId = init.subIndustryId
      this.businessLocationId = init.businessLocationId
      this.noOfEmployees = init.noOfEmployees
      this.whatDescribesBusinessId = init.whatDescribesBusinessId
      this.coveredByAwardsId = init.coveredByAwardsId
      this.modernAwardsId = init.modernAwardsId
      this.agreementNameOrCode = init.agreementNameOrCode
      this.businessCoveredId = init.businessCoveredId

      this.businessDescriptions = init.businessDescriptions
      this.yesNoUnsure = init.yesNoUnsure
      this.modernAwards = init.modernAwards
      this.titles = init.titles
      this.genders = init.genders
      this.customerTypes = init.customerTypes
      this.regions = init.regions
      this.awardIndustries = init.awardIndustries
      this.awardSubIndustries = init.awardSubIndustries
    }
  }
}

export class CurrentUserProfileRequest {
  titleId?: string
  firstName: string
  lastName: string
  customerTypeId: string
  phone?: string
  emailAddress: string
  businessName?: string
  businessABN?: string
  industryId?: string
  subIndustryId?: string
  businessLocationId?: string
  noOfEmployees?: string
  whatDescribesBusinessId?: string
  coveredByAwardsId?: string
  modernAwardsId?: string
  agreementNameOrCode?: string
  businessCoveredId?: string

  constructor(init?: CurrentUserProfile) {
    if (init) {
      this.titleId = init.titleId
      this.firstName = init.firstName
      this.lastName = init.lastName
      this.customerTypeId = init.customerTypeId
      this.phone = init.phone
      this.emailAddress = init.emailAddress
      this.businessName = init.businessName
      this.businessABN = init.businessABN
      this.industryId = init.industryId
      this.subIndustryId = init.subIndustryId
      this.businessLocationId = init.businessLocationId
      this.noOfEmployees = init.noOfEmployees
      this.whatDescribesBusinessId = init.whatDescribesBusinessId
      this.coveredByAwardsId = init.coveredByAwardsId
      this.modernAwardsId = init.modernAwardsId
      this.agreementNameOrCode = init.agreementNameOrCode
      this.businessCoveredId = init.businessCoveredId
    }
  }
}

export interface IEnquiry {
  enquiryId: string
  isOpen: boolean
  isSaved: boolean
  businessName?: string
  businessABN?: string
  tradingName?: string
  businessAddressLine1?: string
  businessAddressLine2?: string
  businessSuburb?: string
  businessPostcode?: string
  businessState?: string
  businessPhone?: string
  otherQuestions?: string
  apprenticeOrTraineeId?: string
  completingInternship?: boolean
  employmentTypeId?: string
  interpreterRequired?: boolean
  languageId?: string
  mainDuties?: string
  noOfEmployees?: string
  officeLocationId?: string
  personDescriptionIds?: string[]
  visaHolder?: boolean
  visaTypeId?: string
  countryId?: string
  employmentStartDate?: string
  employmentEndDate?: string
  otherInformation?: string
  independentContractorId?: string
  genuineContractEmployeeTypeId?: string
  agreement?: boolean
  dateOfBirth?: string
  employeeSuburb?: string
  employeePostcode?: string
  employeeState?: string
  paidLeaveId?: string
  occupation?: string
  nominateSomeoneToAct?: boolean
  nomineeFullName?: string
  nomineeEmailAddress?: string
  nomineePhone?: string
  haveSpokenToEmployer?: string
  notSpokenToEmployerReasonId?: string
  outcomeOfSpokenToEmployer?: string
  areOthersAffectedId?: string
  hasSupportingEvidence?: boolean
  supportingEvidenceIds?: string[]
  permissionToContact?: string
  employeerFullName?: string
  employeerPhone?: string
  employeerEmailAddress?: string
  hourlyPayRate?: string

  isEmployeer?: boolean //This never gets saved, only for UI
  isIC?: boolean //This never gets saved, only for UI
  isER?: boolean //This never gets saved, only for UI
  isenle?: boolean //This never gets saved, only for UI
  isEE?: boolean //This never gets saved, only for UI
  isSBE?: boolean //This never gets saved, only for UI
  isERR?: boolean //This never gets saved, only for UI
  isRW?: boolean //This never gets saved, only for UI
  isHRW?: boolean //This never gets saved, only for UI
  isETU?: boolean //This never gets saved, only for UI

  isSeekingInformation?: boolean //This never gets saved, only for UI

  employmentTypes: any[]
  apprenticeTypes: any[]
  officeLocationTypes: any[]
  personDescTypes: any[]
  languageTypes: any[]
  visaTypes: any[]
  genuineContractEmployeeTypes: any[]
  paidLeaveTypes: any[]
  countryTypes: any[]
  independentContractorTypes: any[]
  customerTypes: any[]
  notSpokenToEmployerTypes: any[]
  othersAffectedTypes: any[]
  evidenceTypes: any[]
  occupationTypes: any[]

  referenceTypes: IEnquiryReferenceItems
}

export class Enquiry implements IEnquiry {
  enquiryId = ''
  isOpen = false
  isSaved = false
  businessName?: string = ''
  businessABN?: string = ''
  tradingName?: string = ''
  businessAddressLine1?: string = ''
  businessAddressLine2?: string = ''
  businessSuburb?: string = ''
  businessPostcode?: string = ''
  businessState?: string = ''
  businessPhone?: string = ''
  otherQuestions?: string = ''
  apprenticeOrTraineeId?: string = ''
  completingInternship?: boolean = null
  employmentTypeId?: string = ''
  interpreterRequired?: boolean = null
  languageId?: string = ''
  mainDuties?: string = ''
  noOfEmployees?: string = ''
  officeLocationId?: string = ''
  personDescriptionIds?: string[] = null
  visaHolder?: boolean = null
  visaTypeId?: string = ''
  countryId?: string = ''
  employmentStartDate?: string = ''
  employmentEndDate?: string = ''
  otherInformation?: string = ''
  independentContractorId?: string = ''
  genuineContractEmployeeTypeId?: string = ''
  agreement?: boolean = false
  dateOfBirth?: string = ''
  employeeSuburb?: string = ''
  employeePostcode?: string = ''
  employeeState?: string = ''
  paidLeaveId?: string = ''
  occupation?: string = ''
  nominateSomeoneToAct?: boolean = null
  nomineeFullName?: string = ''
  nomineeEmailAddress?: string = ''
  nomineePhone?: string = ''
  haveSpokenToEmployer?: string = ''
  notSpokenToEmployerReasonId?: string = ''
  outcomeOfSpokenToEmployer?: string = ''
  areOthersAffectedId?: string = ''
  hasSupportingEvidence?: boolean = null
  supportingEvidenceIds?: string[] = null
  permissionToContact?: string = ''
  employeerFullName?: string = ''
  employeerPhone?: string = ''
  employeerEmailAddress?: string = ''
  hourlyPayRate?: string = ''

  isEmployeer?: boolean = false //This never gets saved, only for UI
  isIC?: boolean = false //This never gets saved, only for UI
  isER?: boolean = false //This never gets saved, only for UI
  isenle?: boolean //This never gets saved, only for UI
  isEE?: boolean = false //This never gets saved, only for UI
  isSBE?: boolean = false //This never gets saved, only for UI
  isERR?: boolean = false //This never gets saved, only for UI
  isRW?: boolean = false //This never gets saved, only for UI
  isHRW?: boolean = false //This never gets saved, only for UI
  isETU?: boolean = false //This never gets saved, only for UI

  employmentTypes: any[] = []
  apprenticeTypes: any[] = []
  officeLocationTypes: any[] = []
  personDescTypes: any[] = []
  languageTypes: any[] = []
  visaTypes: any[] = []
  genuineContractEmployeeTypes: any[] = []
  paidLeaveTypes: any[] = []
  countryTypes: any[] = []
  independentContractorTypes: any[] = []
  customerTypes: any[] = []
  notSpokenToEmployerTypes: any[] = []
  othersAffectedTypes: any[] = []
  evidenceTypes: any[] = []
  occupationTypes: any[] = []

  referenceTypes: IEnquiryReferenceItems = null

  constructor(init?: Enquiry) {
    if (init) {
      ;(this.enquiryId = init.enquiryId),
        (this.businessName = init.businessName),
        (this.businessABN = init.businessABN),
        (this.tradingName = init.tradingName),
        (this.businessAddressLine1 = init.businessAddressLine1),
        (this.businessAddressLine2 = init.businessAddressLine2),
        (this.businessSuburb = init.businessSuburb),
        (this.businessPostcode = init.businessPostcode),
        (this.businessState = init.businessState),
        (this.businessPhone = init.businessPhone),
        (this.otherQuestions = init.otherQuestions),
        (this.apprenticeOrTraineeId = init.apprenticeOrTraineeId),
        (this.completingInternship = init.completingInternship),
        (this.employmentTypeId = init.employmentTypeId),
        (this.interpreterRequired = init.interpreterRequired),
        (this.languageId = init.languageId),
        (this.mainDuties = init.mainDuties),
        (this.noOfEmployees = init.noOfEmployees),
        (this.officeLocationId = init.officeLocationId),
        (this.personDescriptionIds = init.personDescriptionIds),
        (this.visaHolder = init.visaHolder),
        (this.visaTypeId = init.visaTypeId),
        (this.countryId = init.countryId),
        (this.employmentStartDate = init.employmentStartDate),
        (this.employmentEndDate = init.employmentEndDate),
        (this.otherInformation = init.otherInformation),
        (this.genuineContractEmployeeTypeId =
          init.genuineContractEmployeeTypeId),
        (this.independentContractorId = init.independentContractorId),
        (this.agreement = init.agreement),
        (this.dateOfBirth = init.dateOfBirth),
        (this.isEmployeer = init.isEmployeer),
        (this.isIC = init.isIC),
        (this.isER = init.isER),
        (this.isenle = init.isenle),
        (this.isEE = init.isEE),
        (this.isSBE = init.isSBE),
        (this.isERR = init.isERR),
        (this.isRW = init.isRW),
        (this.isHRW = init.isHRW),
        (this.isETU = init.isETU),
        (this.employeeSuburb = init.employeeSuburb),
        (this.employeePostcode = init.employeePostcode),
        (this.employeeState = init.employeeState),
        (this.paidLeaveId = init.paidLeaveId),
        (this.occupation = init.occupation),
        (this.nominateSomeoneToAct = init.nominateSomeoneToAct),
        (this.nomineeFullName = init.nomineeFullName),
        (this.nomineeEmailAddress = init.nomineeEmailAddress),
        (this.nomineePhone = init.nomineePhone),
        (this.haveSpokenToEmployer = init.haveSpokenToEmployer),
        (this.notSpokenToEmployerReasonId = init.notSpokenToEmployerReasonId),
        (this.outcomeOfSpokenToEmployer = init.outcomeOfSpokenToEmployer),
        (this.areOthersAffectedId = init.areOthersAffectedId),
        (this.hasSupportingEvidence = init.hasSupportingEvidence),
        (this.supportingEvidenceIds = init.supportingEvidenceIds),
        (this.permissionToContact = init.permissionToContact),
        (this.employeerFullName = init.employeerFullName),
        (this.employeerPhone = init.employeerPhone),
        (this.employeerEmailAddress = init.employeerEmailAddress),
        (this.hourlyPayRate = init.hourlyPayRate),
        (this.employmentTypes = init.employmentTypes),
        (this.apprenticeTypes = init.apprenticeTypes),
        (this.officeLocationTypes = init.officeLocationTypes),
        (this.personDescTypes = init.personDescTypes),
        (this.languageTypes = init.languageTypes),
        (this.visaTypes = init.visaTypes),
        (this.genuineContractEmployeeTypes = init.genuineContractEmployeeTypes),
        (this.paidLeaveTypes = init.paidLeaveTypes),
        (this.countryTypes = init.countryTypes),
        (this.independentContractorTypes = init.independentContractorTypes),
        (this.customerTypes = init.customerTypes),
        (this.notSpokenToEmployerTypes = init.notSpokenToEmployerTypes),
        (this.othersAffectedTypes = init.othersAffectedTypes),
        (this.evidenceTypes = init.evidenceTypes),
        (this.occupationTypes = init.occupationTypes),
        (this.referenceTypes = init.referenceTypes)
    }
  }
}

export class EnquiryTellUsMoreStepOneRequest {
  enquiryId: string
  businessName?: string
  businessABN?: string
  tradingName?: string
  businessAddressLine1?: string
  businessAddressLine2?: string
  businessSuburb?: string
  businessPostcode?: string
  businessState?: string
  businessPhone?: string
  apprenticeOrTraineeId?: string
  completingInternship?: boolean
  employmentTypeId?: string
  interpreterRequired?: boolean
  languageId?: string
  noOfEmployees?: string
  officeLocationId?: string
  personDescriptionIds?: string[]
  visaHolder?: boolean
  visaTypeId?: string
  countryId?: string
  independentContractorId?: string
  genuineContractEmployeeTypeId?: string
  dateOfBirth?: string
  employeeSuburb?: string
  employeePostcode?: string
  employeeState?: string
  paidLeaveId?: string

  constructor(init?: Enquiry) {
    if (init) {
      this.enquiryId = init.enquiryId
      this.businessName = init.businessName
      this.businessABN = init.businessABN
      this.tradingName = init.tradingName
      this.businessAddressLine1 = init.businessAddressLine1
      this.businessAddressLine2 = init.businessAddressLine2
      this.businessSuburb = init.businessSuburb
      this.businessPostcode = init.businessPostcode
      this.businessState = init.businessState
      this.businessPhone = init.businessPhone
      this.apprenticeOrTraineeId = init.apprenticeOrTraineeId
      this.completingInternship = init.completingInternship
      this.employmentTypeId = init.employmentTypeId
      this.interpreterRequired = init.interpreterRequired
      this.languageId = init.languageId
      this.noOfEmployees = init.noOfEmployees
      this.officeLocationId = init.officeLocationId
      this.personDescriptionIds = init.personDescriptionIds
      this.visaHolder = init.visaHolder
      this.visaTypeId = init.visaTypeId
      this.countryId = init.countryId
      this.independentContractorId = init.independentContractorId
      this.genuineContractEmployeeTypeId = init.genuineContractEmployeeTypeId
      this.dateOfBirth = init.dateOfBirth
      this.employeeSuburb = init.employeeSuburb
      this.employeePostcode = init.employeePostcode
      this.employeeState = init.employeeState
      this.paidLeaveId = init.paidLeaveId
    }
  }
}

export class EnquiryTellUsMoreStepTwoRequest {
  enquiryId: string
  mainDuties?: string
  employmentStartDate?: string
  employmentEndDate?: string
  otherInformation?: string
  occupation?: string
  nominateSomeoneToAct?: boolean
  nomineeFullName?: string
  nomineeEmailAddress?: string
  nomineePhone?: string
  haveSpokenToEmployer?: string
  notSpokenToEmployerReasonId?: string
  outcomeOfSpokenToEmployer?: string
  areOthersAffectedId?: string
  hasSupportingEvidence?: boolean
  supportingEvidenceIds?: string[]
  permissionToContact?: string
  employeerFullName?: string
  employeerPhone?: string
  employeerEmailAddress?: string
  hourlyPayRate?: string

  constructor(init?: Enquiry) {
    if (init) {
      this.enquiryId = init.enquiryId
      this.mainDuties = init.mainDuties
      this.employmentStartDate = init.employmentStartDate
      this.employmentEndDate = init.employmentEndDate
      this.otherInformation = init.otherInformation
      this.occupation = init.occupation
      this.nominateSomeoneToAct = init.nominateSomeoneToAct
      this.nomineeFullName = init.nomineeFullName
      this.nomineeEmailAddress = init.nomineeEmailAddress
      this.nomineePhone = init.nomineePhone
      this.haveSpokenToEmployer = init.haveSpokenToEmployer
      this.notSpokenToEmployerReasonId = init.notSpokenToEmployerReasonId
      this.outcomeOfSpokenToEmployer = init.outcomeOfSpokenToEmployer
      this.areOthersAffectedId = init.areOthersAffectedId
      this.hasSupportingEvidence = init.hasSupportingEvidence
      this.supportingEvidenceIds =
        init.supportingEvidenceIds && init.supportingEvidenceIds.length > 0
          ? init.supportingEvidenceIds
          : null
      this.permissionToContact = init.permissionToContact
      this.employeerFullName = init.employeerFullName
      this.employeerPhone = init.employeerPhone
      this.employeerEmailAddress = init.employeerEmailAddress
      this.hourlyPayRate = init.hourlyPayRate
    }
  }
}

export class EnquiryTellUsMoreSubmitRequest {
  enquiryId: string
  agreement?: boolean

  constructor(init?: Enquiry) {
    if (init) {
      this.enquiryId = init.enquiryId
      this.agreement = init.agreement
    }
  }
}

export class CancelOrCloseRequest {
  enquiryId: string
  constructor(id?: string) {
    if (id) {
      this.enquiryId = id
    }
  }
}

export interface IEnquiryStepProps {
  showreadonly: boolean
  enquiry?: IEnquiry
  onError?: (error: any) => void
}

export enum EmploymentTypes {
  Unsure = 'Unsure',
}

export enum YesNoTypes {
  Yes = 'Yes',
}

export enum EmployeerSpokenTypes {
  Yes = 'Yes',
  NotYet = 'Not yet',
}

export enum PermissionToContactTypes {
  Yes = 'Yes',
  No = 'No',
  NA = 'N/A - seeking information only',
}

export enum EnquiryChannelTypes {
  MyAccount = 'My Account',
  InboundPhone = 'Inbound Phone',
}

export enum ReasonNotSpokenToEmployersTypes {
  SeekingInformationOnly = 'Seeking information only',
}

export const EmployeerSpokenOptions: ISelectItem[] = [
  {
    key: EmployeerSpokenTypes.Yes,
    value: EmployeerSpokenTypes.Yes,
    text: EmployeerSpokenTypes.Yes,
  },
  {
    key: EmployeerSpokenTypes.NotYet,
    value: EmployeerSpokenTypes.NotYet,
    text: EmployeerSpokenTypes.NotYet,
  },
]

export const PermissionToContactOptions: ISelectItem[] = [
  {
    key: PermissionToContactTypes.Yes,
    value: PermissionToContactTypes.Yes,
    text: PermissionToContactTypes.Yes,
  },
  {
    key: PermissionToContactTypes.No,
    value: PermissionToContactTypes.No,
    text: PermissionToContactTypes.No,
  },
  {
    key: PermissionToContactTypes.NA,
    value: PermissionToContactTypes.NA,
    text: PermissionToContactTypes.NA,
  },
]

export enum EnquiryStatuses {
  EnquirySaved = 'Enquiry Saved',
  EnquiryOpen = 'Enquiry Open',
  EnquiryClosed = 'Enquiry Closed',
  InProgress = 'In Progress',
  EnquiryClosedNotSubmitted = 'Enquiry Closed - Not Submitted',
  EnquiryCancel = 'Enquiry Cancelled',
  EnquiryRecommendedLinksProvided = 'Recommended links provided',
  EnquiryAdviceProvided = 'Advice Provided',
  EnquiryAssistanceCompleted = 'Assistance Completed',
  EnquiryResponseToRequestForInformationReceived = 'Response to Request for Information Received',
  EnquiryRequestForInformationSent = 'Request for information sent',
  EnquiryWithRefNumber = 'Reference number',
  EnquiryError = 'Error',
  EnquiryUnableToContact = 'Unable to contact',
}

export const EnquiryFormFieldMapping = new Map<string, string>([
  ['businessABN', 'Business ABN'],
  ['businessName', 'Business name'],
  ['tradingName', "What's the trading name?"],
  ['businessAddressLine1', 'Business address line 1'],
  ['businessAddressLine2', 'Business address line 2'],
  ['businessSuburb', 'Business suburb'],
  ['businessPostcode', 'Business postcode'],
  ['businessState', 'Business state / territory'],
  ['businessPhone', 'Business phone'],
  ['noOfEmployees', 'Number of employees'],
  ['employmentTypeId', 'What is the employment type?'],
  ['paidLeaveId', 'Do you receive paid leave?'],
  ['apprenticeOrTraineeId', 'Is the employee an apprentice or trainee?'],
  ['personDescriptionIds', 'What else describes the employee?'],
  ['completingInternship', 'Is the employee an intern?'],
  [
    'officeLocationId',
    'If we need to meet with you, which office location would you prefer to attend?',
  ],
  ['interpreterRequired', 'Do you need an interpreter?'],
  ['languageId', 'What language?'],
  ['independentContractorId', 'Are you working as an independent contractor?'],
  [
    'genuineContractEmployeeTypeId',
    'Are you a genuine contractor, or do you believe you should be classified as an employee?',
  ],
  ['dateOfBirth', "What's your date of birth?"],
  ['employeeSuburb', 'What suburb do you live in?'],
  ['employeePostcode', "What's your postcode?"],
  ['employeeState', 'What state do you live in?'],
  ['visaHolder', 'Is the employee a visa holder?'],
  ['visaTypeId', "What's their visa type?"],
  ['countryId', "What's your citizenship country?"],

  ['occupation', 'What is your occupation?'],
  ['mainDuties', "What are the employee's main duties?"],
  ['employmentStartDate', 'What was the employment start date?'],
  ['employmentEndDate', 'What was the employment end date?'],
  [
    'haveSpokenToEmployer',
    'Have you spoken to your employer about your question or issue?',
  ],
  ['notSpokenToEmployerReasonId', "Why haven't you spoken to your employer?"],
  [
    'outcomeOfSpokenToEmployer',
    'What happened when you spoke to your employer?',
  ],
  [
    'areOthersAffectedId',
    "Are other employees affected by the issue you're enquiring about?",
  ],
  ['hourlyPayRate', "What's your hourly pay rate (before tax)?"],
  [
    'hasSupportingEvidence',
    'Do you have any evidence to support your enquiry?',
  ],
  ['supportingEvidenceIds', 'What evidence do you have?'],
  [
    'nominateSomeoneToAct',
    'Do you want to nominate someone to act on your behalf?',
  ],
  ['nomineeFullName', 'Their full name'],
  ['nomineeEmailAddress', 'Their email address'],
  ['nomineePhone', 'Their Phone number'],
  [
    'permissionToContact',
    'I give permission for the FWO to contact my employer for the purpose detailed',
  ],
  ['employeerFullName', 'Employer or manager name'],
  ['employeerPhone', 'Employer or manager telephone number'],
  ['employeerEmailAddress', 'Employer or manager email address'],
  [
    'otherInformation',
    'Is there anything else you want to tell us about your enquiry?',
  ],
  [
    'businessCoveredId',
    'Do you know which modern award the business is covered by?',
  ],
])

export const EnquiryExistingEmployeeFormFieldMapping = new Map<string, string>([
  ['mainDuties', 'What are your main duties?'],
  ['apprenticeOrTraineeId', 'Are you an apprentice or trainee?'],
  ['completingInternship', 'Are you completing an internship?'],
  ['personDescriptionIds', 'What else describes you?'],
  ['employmentStartDate', 'What was your employment start date?'],
  ['employmentEndDate', 'What was your employment end date?'],
  ['visaHolder', 'Are you a visa holder?'],
])

export const EnquiryEmployerNoLongerEmployeedFormFieldMapping = new Map<
  string,
  string
>([
  ['mainDuties', 'What are your main duties?'],
  ['apprenticeOrTraineeId', 'Are you an apprentice or trainee?'],
  ['completingInternship', 'Are you completing an internship?'],
  ['personDescriptionIds', 'What else describes you?'],
  ['employmentStartDate', 'What was your employment start date?'],
  ['employmentEndDate', 'What was your employment end date?'],
  ['visaHolder', 'Are you a visa holder?'],
])

export const EnquiryEmployerFormFieldMapping = new Map<string, string>([
  ['mainDuties', "What are the employee's main duties?"],
])

export const EnquirySBEFormFieldMapping = new Map<string, string>([
  ['mainDuties', "What are the employee's main duties?"],
])

export const EnquiryIndContractorFormFieldMapping = new Map<string, string>([
  ['mainDuties', "What are the employee's main duties?"],
])

export const EnquiryGetHelpFieldMapping = new Map<string, string>([
  ['needInfoAboutId', 'I need help with'],
  ['needInfoSubAboutId', 'Select from the following options'],
  ['otherQuestions', 'Briefly describe your issue or question'],
])

export const EnquiryCheckDetailFieldMapping = new Map<string, string>([
  ['titleId', 'Title'],
  ['firstName', 'First name'],
  ['lastName', 'Last name'],
  ['customerTypeId', 'Customer type'],
  ['phone', 'Phone number'],
  ['businessName', 'Business name'],
  ['businessABN', 'ABN (Australian Business Number)'],
  ['industryId', 'Business industry'],
  ['subIndustryId', 'Sub-Industry'],
  ['businessLocationId', 'Location of business'],
  ['noOfEmployees', 'How many employees does the business have?'],
  ['whatDescribesBusinessId', 'What else describes the business?'],
  ['modernAwardsId', 'Award'],
  [
    'coveredByAwardsId',
    'Is the business or its employees covered by any other awards or registered agreements (AWA, ITEA, collective or enterprise agreement) or Fair Work Commission Order?',
  ],
  ['agreementNameOrCode', 'Name or code of award or agreement or order'],
  [
    'businessCoveredId',
    'Do you know which modern award the business is covered by?',
  ],
])
